import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardImg, CardText, CardBody, CardTitle, CardHeader, Button } from 'reactstrap';
import sostenibilidad from './Imagenes/Insignias/ETICA_SOSTENIBILIDAD.png';
import liderazgo from './Imagenes/Insignias/LIDERAZGO_AUTOAGENCIA.png';
import creatibidad from './Imagenes/Insignias/CREATIVIDAD_INNOVACION_EMPRENDIMIENTO.png';
import interaccion from './Imagenes/Insignias/INTERACCION_COMUNICACION.png';
import autonomia from './Imagenes/Insignias/AUTONOMIA_APRENDIZAJE.png';
import estrategia from './Imagenes/Insignias/ESTRATEGIA_CONOCIMIENTO.png';

import shark from './Imagenes/IconInsignias/shark.svg';
//import sostenibilidad from './Imagenes/IconInsignias/ciudadania-ETICA(B).svg';
//import liderazgo from './Imagenes/IconInsignias/liderazgo-AUTOAGENCIA(B).svg';
//import creatibidad from './Imagenes/IconInsignias/CREATIVIDAD(B).svg';
//import interaccion from './Imagenes/IconInsignias/interaccion-COMUNICACION(B).svg';
//import autonomia from './Imagenes/IconInsignias/Autonomia-APRENDIZAJE(B).svg';
//import estrategia from './Imagenes/IconInsignias/Gestion-ESTRATEGICA(B).svg';

const imgInsignia = [shark, sostenibilidad, liderazgo, creatibidad, interaccion, autonomia, estrategia];

const colors = ['#FFFFFF', '#354750', '#F48700', '#A72186', '#1DA656', '#EA3B13', '#1F58AB']

class InsigniaCard extends React.Component {
    constructor(props) {
        super(props);
        const {
            idaexinsignia = 0, nombre = '', descripcion = ''
        } = props.insignia || {};
    }

    render() {
        return (
            <div id={"InsiniaCard-" + this.props.insignia.idaexinsignia} className="insignia-card py-2" style={{ height: "100%" }}>
                <Card style={{ height: "100%" }}>
                    <CardHeader style={{ color: '#717D81', backgroundColor: colors[0], borderColor: '#333' }}>
                        <div class="expense">
                            <img src={imgInsignia[this.props.insignia.idaexinsignia]} style={{ width: "10%", height: "5%" }} />
                            &nbsp;
                            <span style={{ fontSize: "0.9vw" }} >{this.props.insignia.nombre}</span>
                        </div>
                    </CardHeader>
                    {/*<CardImg top width="10%" src={imgInsignia[this.props.insignia.idaexinsignia]} alt="Card image cap" />*/}
                    <CardBody>                        
                        <CardText>{this.props.insignia.descripcion}</CardText>
                    </CardBody>
                </Card>               
            </div>
        )
    }
}

InsigniaCard.propTypes = {
    insignia: PropTypes.shape({        
        idaexinsignia: PropTypes.number.isRequired,
        nombre: PropTypes.string.isRequired,
        descripcion: PropTypes.string.isRequired        
    }).isRequired
};

export default InsigniaCard;
